import { ReactNode, useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/Button';

interface CopyWrapperProps {
	children: ReactNode;
	valueToCopy: string;
	wrapperClassName?: string;
	buttonClassName?: string;
	tooltipText?: string;
	onCopy?: () => void;
}

const CopyWrapper = ({
	children,
	valueToCopy,
	wrapperClassName = '',
	buttonClassName = '',
	tooltipText = 'Copiado',
	onCopy,
}: CopyWrapperProps) => {
	const [showTooltip, setShowTooltip] = useState(false);

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(valueToCopy);
			setShowTooltip(true);
			setTimeout(() => setShowTooltip(false), 2000);
			onCopy?.();
		} catch (err) {
			console.error('Failed to copy text: ', err);
		}
	};

	return (
		<div className={`relative ${wrapperClassName}`}>
			{children}
			<Button
				type="button"
				variant="text"
				text=""
				endIcon={
					showTooltip ? (
						<Check className="h-4 w-4 text-zinc-500" />
					) : (
						<Copy className="h-4 w-4 text-zinc-500" />
					)
				}
				onClick={handleCopy}
				className={`absolute right-1 top-1/2 h-6 w-6 -translate-y-1/2 p-1 ${buttonClassName}`}
				aria-label="Copy to clipboard"
			/>
			{showTooltip && (
				<div className="absolute right-10 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-md bg-zinc-500 px-2 py-1 text-xs text-light">
					{tooltipText}
					<div className="absolute -right-1 top-1/2 h-2 w-2 -translate-y-1/2 rotate-45 bg-zinc-500" />
				</div>
			)}
		</div>
	);
};

export { CopyWrapper };
